import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { cookie } from '@ifeng-fe/ui_base';
import { h5PageCount } from 'ThreeTerminal_utils';
import errorBoundary from '@ifeng-fe/errorBoundary';

let isFirstPlayAuido = true;

class Audio extends React.PureComponent {
    static propTypes = {
        videoConfig: PropTypes.object,
        pageInfo: PropTypes.object,
    };

    state = {
        videoIcon: true,
        videoPlay: false,
        videoPause: false,
        progresWidth: 0,
        videoUrl: this.props.videoConfig.audioUrl,
        timeLen: this.props.videoConfig.duration,
    };

    componentDidMount() {
        const audioDom = this.refs.audioDom;
        const { videoConfig } = this.props;
        const timeLenPro = videoConfig.duration;
        let setTimeStr = null;

        audioDom.addEventListener('timeupdate', () => {
            setTimeStr = setTimeout(() => {
                this.setState({
                    progresWidth: `${this.timePercentage(audioDom.currentTime)}%`,
                    timeLen: timeLenPro - Math.floor(audioDom.currentTime),
                });
            });
        });

        audioDom.addEventListener('ended', () => {
            setTimeStr = null;
            setTimeout(() => {
                this.setState({
                    videoIcon: true,
                    videoPlay: false,
                    videoPause: false,
                    timeLen: timeLenPro,
                    progresWidth: 0,
                });
            }, 1000);
        });
    }

    getUid() {
        let uid = '';

        if (cookie.get('userid') === '') {
            uid = this.getRandomUid();
            cookie.set('userid', uid);
        } else {
            uid = cookie.get('userid');
        }

        return uid;
    }

    mos() {
        const ua = typeof navigator === 'object' ? navigator.userAgent : '';

        if (ua.match(/iphone|ipod/gi) || ua.match(/ipad/gi)) {
            return 'iphone';
        } else if (ua.match(/android/gi)) {
            return 'android';
        } else {
            return 'pc';
        }
    }

    getRandomUid() {
        let tn = new Date().getTime() + (Math.round((1 << 12) * Math.random()) << 24);
        const sn = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZXX';
        let uuid = '';

        const fn1 = sn.charAt(parseInt(tn & 63));

        tn >>= 6;
        const fn2 = sn.charAt(parseInt(tn & 63));

        tn >>= 6;
        const fn3 = sn.charAt(parseInt(tn & 63));

        tn >>= 6;
        const fn4 = sn.charAt(parseInt(tn & 63));

        tn >>= 6;
        const fn5 = sn.charAt(parseInt(tn & 63));

        tn >>= 6;
        const fn6 = sn.charAt(parseInt(tn & 63));

        uuid += fn6 + fn5 + fn4 + fn3 + fn2 + fn1;

        return uuid;
    }

    timePercentage = currentTime => {
        const { videoConfig } = this.props;
        const timeLenPro = videoConfig.duration;

        return Math.floor((Math.floor(currentTime) / timeLenPro) * 100);
    };
    timeFormatFn = () => {
        const { timeLen } = this.state;
        const timeNum = timeLen;
        const min = Math.floor(timeNum / 60) < 10 ? `0${Math.floor(timeNum / 60)}` : Math.floor(timeNum / 60);
        const sec = timeNum % 60 < 10 ? `0${timeNum % 60}` : timeNum % 60;

        return `${min}:${sec}`;
    };

    videoPlayFn = () => {
        const { pageInfo } = this.props;

        if (isFirstPlayAuido && pageInfo && pageInfo.clickFirstAudio) {
            isFirstPlayAuido = false;
            h5PageCount([pageInfo.clickFirstAudio]);
        }

        if (pageInfo && pageInfo.clickAudioPlay) {
            h5PageCount([pageInfo.clickAudioPlay]);
        }
        this.setState({
            videoPlay: true,
            videoIcon: false,
            videoPause: false,
        });

        this.refs.audioDom.play();
    };

    videoPauseFn = () => {
        this.setState({
            videoPlay: false,
            videoIcon: false,
            videoPause: true,
        });
        this.refs.audioDom.pause();
    };

    render() {
        const { videoConfig } = this.props;
        const { videoIcon, videoPlay, videoPause, progresWidth, videoUrl } = this.state;
        const style = {
            width: progresWidth,
        };

        return (
            <section className={styles.audioBox}>
                <div className={styles.info}>
                    <h2 className={styles.title}>{videoConfig.title}</h2>
                    <p className={styles.source}>来源：凤凰新闻客户端</p>
                </div>
                <div className={styles.buttons}>
                    {videoIcon && <span className={styles.icon} onClick={this.videoPlayFn} />}
                    {videoPlay && <span className={styles.playIcon} onClick={this.videoPauseFn} />}
                    {videoPause && <span className={styles.pauseIcon} onClick={this.videoPlayFn} />}
                    <time className={styles.time}>{this.timeFormatFn()}</time>
                </div>
                <audio ref="audioDom" className={styles.audioDom} preload="none">
                    <source src={videoUrl} />
                </audio>
                <div className={styles.progresBar} style={style} />
            </section>
        );
    }
}

export default errorBoundary(Audio);
